<template>
  <v-jsoneditor
    :value="getProp('value', '')"
    :options="getProp('options')"
    :height="getProp('height')"
    :plus="getProp('plus')"
    @error="handleError"
    @input="handleInput"
  />
</template>

<script>
import VJsoneditor from 'v-jsoneditor';
import ComponentInternalMixin from '../../core/ComponentInternalMixin';

export default {
  name: 'ClicJsonInterno',
  inheritAttrs: false,
  mixins: [ComponentInternalMixin],
  components: {
    VJsoneditor
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value);
    },
    handleError(error) {
      this.$emit('error', error);
    }
  }
};
</script>
